export default `
mutation UpdateClient($serviceProviderId: ID!, $id: ID!, $propertyIds: [ID!], $firstName: String, $lastName: String) {
  updateClient(serviceProviderId: $serviceProviderId, id: $id, propertyIds: $propertyIds, firstName: $firstName, lastName: $lastName) {
    id
    serviceProviderId
    updatedAt
    propertyIds
    firstName
    lastName
    email
    isArchived
    isDeleted
  }
}
`;
